import { z } from "zod";

import { machineSchema } from "./machine";

const machineProofOfLifeInputSchema = machineSchema.pick({
	id: true,
	alias: true,
	assetId: true,
	lastProofOfLifeTimeStamp: true,
});

export const machineProofOfLifeSchema = machineProofOfLifeInputSchema;

export type MachineProofOfLife = z.infer<typeof machineProofOfLifeSchema>;

export const parseMachineProofOfLifeResponse = (response: unknown[]): MachineProofOfLife[] => {
	return z.array(machineProofOfLifeSchema).parse(response);
};
